import { selectCurrentHotelName, selectLoggedinUserName } from 'accessors'
import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import TextInputWithEmoji from 'components/ReusableComponents/ManageHotel/TextInputWithEmoji'
import SavibookHeader from 'components/ReusableComponents/Savibook/Header'
import SavibookHero from 'components/ReusableComponents/Savibook/Hero'
import RibbonBanner from 'components/ReusableComponents/Savibook/RibbonBanner'
import Toggle from 'components/ReusableComponents/Toggle'
import { useEffect } from 'react'
import DatePicker from 'react-datepicker'
import { useSelector } from 'react-redux'
import {
  clampDiscountPercentage,
  getPromoCodeWord,
  MAX_DISCOUNT_PERCENTAGE,
  nightsToStayOptions
} from 'utils/promotionHelpers'

import styles from './EditPromoDialog.module.scss'

export const EditPromo = ({
  promoCode,
  setPromoCode,
  minNights,
  setMinNights,
  maxDiscount,
  setMaxDiscount,
  promoTagline,
  setPromoTagline,
  hasPromoValidityDateControls = true,
  hasPromoValidityDate,
  setHasPromoValidityDate,
  promoValidityStartDate,
  setPromoValidityStartDate,
  promoValidityEndDate,
  setPromoValidityEndDate,
  promoToggleLabel = 'Use promotion',
  isUsingDiscount,
  setIsUsingDiscount,
  isPromoValid
}) => {
  const userName = useSelector(selectLoggedinUserName)
  const hotelName = useSelector(selectCurrentHotelName)

  useEffect(() => {
    if (!isUsingDiscount) {
      setPromoCode(null)
      setMinNights(1)
      setMaxDiscount(0)
    }
  }, [isUsingDiscount]) // eslint-disable-line

  const parentChainCode = useSelector(s => s.hotelDetails.parentChainCode)
  const isDemoMode = useSelector(s => s.login.isDemoMode)

  const wordRateCode = getPromoCodeWord(parentChainCode)

  function handlePercentChange(e) {
    setMaxDiscount(clampDiscountPercentage(e.target.value))
  }

  const handleChangeValidityDates = dates => {
    const [start, end] = dates
    setPromoValidityStartDate(start)
    setPromoValidityEndDate(end)
  }

  return (
    <>
      <div className={styles.wrapper}>
        <Toggle
          label={promoToggleLabel}
          className={styles.toggle}
          checked={isUsingDiscount}
          handleChange={e => setIsUsingDiscount(e.target.checked)}
        />
        <div
          className={
            isUsingDiscount ? styles.discountHolder : styles.discountHolderDisabled
          }
        >
          <div className={styles.halfInputRow}>
            <TextInput
              label={`Offer ${wordRateCode}`}
              className={styles.textInput}
              value={promoCode || ''}
              valid={isPromoValid}
              onChange={e => setPromoCode(e.target.value)}
            />
            {promoCode && !isPromoValid && (
              <p className={styles.validationError}>Enter a valid promo code</p>
            )}
          </div>
          <div className={styles.halfInputRow}>
            <Dropdown
              disabled={!promoCode}
              options={nightsToStayOptions}
              label="Minumum nights to stay"
              value={minNights}
              onChange={e => setMinNights(e.target.value)}
            />
          </div>
          <br />
          <div className={styles.halfInputRow}>
            <TextInput
              label="Offer discount percentage"
              value={maxDiscount ?? 0}
              type="number"
              className={styles.textInput}
              min={0}
              max={MAX_DISCOUNT_PERCENTAGE}
              onChange={handlePercentChange}
              onBlur={e => (e.target.value === '' ? setMaxDiscount(0) : false)}
            />
          </div>
        </div>
        <div className={styles.inputRow}>
          <TextInputWithEmoji
            label="Offer tagline"
            className={styles.textInput}
            value={promoTagline}
            onValueChange={setPromoTagline}
            maxLength={20}
          />
        </div>
        <div
          style={{
            marginTop: 20,
            opacity: isUsingDiscount ? 1 : 0.3,
            pointerEvents: isUsingDiscount ? 'auto' : 'none'
          }}
        >
          {hasPromoValidityDateControls && (
            <>
              <Toggle
                label={`Offer is valid between specific dates`}
                className={styles.toggle}
                checked={hasPromoValidityDate}
                handleChange={e => setHasPromoValidityDate(e.target.checked)}
              />
              <div className={styles.fullInputRow}>
                <DatePicker
                  onChange={handleChangeValidityDates}
                  startDate={promoValidityStartDate}
                  endDate={promoValidityEndDate}
                  disabled={!hasPromoValidityDate}
                  selectsRange={true}
                  customInput={
                    <TextInput label="Valid date range" className={styles.textInput} />
                  }
                />
              </div>
            </>
          )}
        </div>
      </div>
      <SavibookHero lightbg>
        <SavibookHeader text={isDemoMode ? 'The Luxury Resort & Spa' : hotelName} />
        <RibbonBanner
          topText={`${userName.replace(/ .*/, '')}, you unlocked`}
          mainText={promoTagline}
        />
      </SavibookHero>
    </>
  )
}
